module.exports = __webpack_public_path__ + "img/icons.f00c6678.svg";